import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import AuthShell from "./AuthShell";
import { api, apiError } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("working"); // working | ok | fail
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setState("fail");
      setMessage("This verification link is missing its token.");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch((e) => {
        setState("fail");
        setMessage(apiError(e));
      });
  }, [token]);

  return (
    <AuthShell title="Email verification" sub="Securing your account.">
      {state === "working" && <p className="text-sm text-zinc-400">Verifying…</p>}
      {state === "ok" && (
        <div data-testid="verify-success" className="flex items-start gap-3 border border-emerald-700/40 bg-emerald-900/10 p-5">
          <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" />
          <p className="text-sm text-zinc-300">
            Your email is verified.{" "}
            <Link to="/app" className="text-[#D4AF37] hover:brightness-110">Enter your dashboard</Link>
          </p>
        </div>
      )}
      {state === "fail" && (
        <div data-testid="verify-failure" className="flex items-start gap-3 border border-red-800/40 bg-red-900/10 p-5">
          <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-400" />
          <p className="text-sm text-zinc-300">{message}</p>
        </div>
      )}
    </AuthShell>
  );
}
